import { IMapState } from '../types';

export function selectIsDrawingMode(state: IMapState): boolean {
  return state.map.isDrawingMode;
}
